import React, { Component } from "react"
import {Switch, Route} from "react-router-dom"

import {Form} from './Form'
import {FormUpdate} from './FormUpdate'


export class UsersPage extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Switch>
                <Route exact path={"/mangarmangaagiinadmin/users"} component={Form}/>
                <Route exact path={"/mangarmangaagiinadmin/users/:user_id/update/"} component={FormUpdate}/>
            </Switch>
        )

    }

}
